import { isNumber, isString, isStringNumber } from '@/components/base-components/utils/types';

type QueryRoot = {
    querySelector?: (selector: string) => Element | null;
} | null | undefined;

type CssVarTarget = {
    style?: {
        setProperty?: (name: string, value: string) => void;
        removeProperty?: (name: string) => void;
    };
} | null | undefined;

export function addUnit(value: unknown, defaultUnit = 'px'): string {
    if (!value) return '';
    if (isNumber(value) || isStringNumber(value)) return `${value}${defaultUnit}`;
    if (isString(value)) return value;

    return '';
}

export function getElement(selector: string, root: QueryRoot = document): Element | null {
    return root?.querySelector?.(selector) ?? null;
}

export function setCssVar(
    name: string,
    value: string,
    target: CssVarTarget = document.documentElement,
): void {
    target?.style?.setProperty?.(name, value);
}

export function removeCssVar(
    name: string,
    target: CssVarTarget = document.documentElement,
): void {
    target?.style?.removeProperty?.(name);
}

export function toggleClasses(element: Element | null | undefined, classes: string[], enabled: boolean): void {
    if (!element) return;

    element.classList[enabled ? 'add' : 'remove'](...classes);
}
